import { z } from 'zod';

import { zodContractItemsTableSearchSchema } from '../-searchParams';

export const zodCreateContractSearchParamsSchema =
  zodContractItemsTableSearchSchema.extend({
    // The shell draft contract this create session works on. Entering the
    // create page without it creates the draft and replace-navigates it into
    // the URL, so the session survives reloads; see useContractShellDraft.ts.
    contractId: z.uuid().optional().catch(undefined),
    // Prefills the create form from the given contract; see useContractForm.ts.
    duplicateContractId: z.uuid().optional().catch(undefined),
    // Prefills the create form from the import job's OCR-extracted data.
    // The PDF is attached server-side from this id; see useContractForm.ts.
    importJobId: z.uuid().optional().catch(undefined),
  });
